import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface ReportDelayData {
  jobId: string;
  estimated_delay_minutes: number;
  delay_reason?: string;
}

export const useReportDelay = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ jobId, estimated_delay_minutes, delay_reason }: ReportDelayData) => {
      const { error } = await supabase
        .from('transport_jobs')
        .update({
          delay_reported_at: new Date().toISOString(),
          estimated_delay_minutes,
          delay_reason: delay_reason || null,
        })
        .eq('id', jobId);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['driver-missions'] });
      toast.success('Retard signalé', {
        description: 'L\'expéditeur a été notifié du retard',
      });
    },
    onError: (error) => {
      console.error('Error reporting delay:', error);
      toast.error('Erreur', {
        description: 'Impossible de signaler le retard. Veuillez réessayer.',
      });
    },
  });

  return {
    reportDelay: mutation.mutateAsync,
    isReporting: mutation.isPending,
  };
};
